import styled from 'styled-components';
import Typography from '../common/Typography';

export default function GroundStoryCard({
  id,
  date,
  count,
  title,
  thumbnailUrl,
  handleClick,
}: {
  id: number;
  date: string;
  count: number;
  title: string;
  thumbnailUrl: string;
  handleClick: () => void;
}) {
  return (
    <CardContainer onClick={handleClick}>
      <Thumbnail src={thumbnailUrl} alt={title} />
      <Content>
        <DateAndCount>
          {date} · 조회수 {count}
        </DateAndCount>
        <Typography variant="h4" ellipsisLines={2}>
          {title}
        </Typography>
      </Content>
    </CardContainer>
  );
}

const CardContainer = styled.div`
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;

  position: relative;
  width: 100%;
  /*
   * 메인 스토리 카드는 9:16(릴스) 비율로 노출되므로
   * 카드 폭을 1:1 시절(300px)보다 다소 좁혀 한 화면에 자연스럽게 들어가도록 한다.
   */
  max-width: 220px;
  overflow: hidden;

  @media (max-width: 768px) {
    max-width: 180px;
  }

  @media (max-width: 480px) {
    max-width: 150px;
  }
  @media (max-width: 375px) {
    max-width: 120px;
  }
`;

const Thumbnail = styled.img`
  width: 100%;
  height: auto;
  /* 메인 노출 썸네일을 릴스 사이즈(9:16)로 통일 */
  aspect-ratio: 9 / 16;
  object-fit: cover;
  display: block;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.gray100};
`;

const Content = styled.div`
  padding: 10px;
`;

const DateAndCount = styled.div`
  font-size: 12px;
  color: #888;
  margin-bottom: 5px;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: #333;
  line-height: 1.4;
`;
